module.exports = __webpack_public_path__ + "img/img50.ac3fc892.png";